module.exports = __webpack_public_path__ + "static/media/DATA CORRECTION.307bfe4e.jpg";